export class TabItem {
  constructor() {
    this._paymentOption = null;
    this._isActive = false;
  }

  static fromPaymentOption(paymentOption) {
    const tabItem = new TabItem();

    tabItem.paymentOption = paymentOption;

    return tabItem;
  }

  set paymentOption(paymentOption) {
    this._paymentOption = paymentOption;
  }
  
  get paymentOption() {
    return this._paymentOption;
  }

  set isActive(isActive) {
    this._isActive = isActive;
  }

  get isActive() {
    return this._isActive;
  }

  toggle() {
    this._isActive = !this._isActive;
  }
}

export class TabsModel {
  constructor() {
    this._paymentOptions = null;
    this._tabItems = [];
  }

  static fromPaymentOptions(paymentOptions) {
    let tabsModel = new TabsModel();

    tabsModel.paymentOptions = paymentOptions;

    for (const paymentOption of paymentOptions) {
      tabsModel.tabItems.unshift(TabItem.fromPaymentOption(paymentOption));
    }

    // mark the first item as selected / active
    tabsModel.tabItems[0].toggle();

    return tabsModel;
  }

  set paymentOptions(paymentOptions) {
    this._paymentOptions = paymentOptions;
  }

  get paymentOptions() {
    return this._paymentOptions;
  }

  set tabItems(tabItems) {
    this._tabItems = tabItems;
  }

  get tabItems() {
    return this._tabItems;
  }

  selectTabItem(selectedTabItem) {
    for (const tabItem of this.tabItems) {
      if (selectedTabItem === tabItem) {
        selectedTabItem.toggle();
      } else {
        tabItem.isActive = false;
      }
    }
  }

  get selectedTabItem() {
    const tabItem = this.tabItems.filter(tab => {
      return tab.isActive;
    })[0];

    return tabItem;
  }
}

export default TabsModel;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit2/model/tabs.model.js